<div *ngIf="!showIntermission" class="app-container vw-100 vh-100 d-flex">
  <div>
    <svg
      class="app-focus-marker"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
  </div>

  <div class="container">
    <div style="margin-top: 6em; text-align: center">
      <ngb-progressbar
        [showValue]="false"
        type="dark"
        [value]="id"
        [max]="stimuli.length"
      ></ngb-progressbar>
    </div>
    <div style="margin-top: 16px; text-align: center">
      {{ id }} / {{ stimuli.length }} abgeschlossen
    </div>
    <div class="row">
      <div class="col-lg-1 col-md-1 col-sm-0"></div>

      <div
        [@fadeInLeft]="animationState"
        style="margin-top: 6em"
        class="col-lg-4 col-md-4 col-sm-12"
      >
        <a
          style="color: #212529 !important; text-decoration: none !important"
          (click)="saveDecisionAndLoadNextItem($event, 0)"
          ><div
            (click)="animate()"
            class="d-flex flex-column align-items-center app-card"
          >
            <div class="row app-brand-name">
              <div class="col-lg-2 col-md-2 col-sm-0"></div>
              <div class="col-lg-5 col-md-5 col-sm-12">
                {{ stimuli[id][0].brandName }}
              </div>
              <div class="col-lg-2 col-md-2 col-sm-0"></div>
            </div>
            <div>
              <img
                class="app-brand-image"
                [src]="getImageFilePath(stimuli[id][0].brandImage)"
              />
            </div>
            <div class="d-flex flex-column">
              <div style="margin-top: 1em" class="row">
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Karosserie
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
                <div class="col-lg-5 col-md-5 col-sm-5">
                  <img
                    style="width: 70px"
                    [src]="getImageFilePath(stimuli[id][0].productSegment)"
                  />
                </div>
              </div>
              <div style="margin-top: 11px" class="row">
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Leistung
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>

                <div class="col-lg-5 col-md-5 col-sm-5">
                  <ng-template #t let-fill="fill">
                    <span class="star" [class.full]="fill === 100">
                      <span class="half" [style.width.%]="fill">&bull;</span
                      >&bull;
                    </span>
                  </ng-template>
                  <ngb-rating
                    [(rate)]="stimuli[id][0].productPerformance"
                    [readonly]="true"
                    [max]="5"
                    [starTemplate]="t"
                  ></ngb-rating>
                </div>
              </div>
              <div class="row">
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Komfort
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
                <div class="col-lg-5 col-md-5 col-sm-5">
                  <ng-template #t let-fill="fill">
                    <span class="star" [class.full]="fill === 100">
                      <span class="half" [style.width.%]="fill">&bull;</span
                      >&bull;
                    </span>
                  </ng-template>
                  <ngb-rating
                    [(rate)]="stimuli[id][0].productComfort"
                    [readonly]="true"
                    [max]="5"
                    [starTemplate]="t"
                  ></ngb-rating>
                </div>
              </div>
              <div
                style="margin-bottom: 1.8em; margin-top: -0.25em"
                class="row"
              >
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Preis
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
                <div
                  style="margin-top: 0.3em"
                  class="col-lg-5 col-md-5 col-sm-5"
                >
                  {{
                    stimuli[id][0].productPrice
                      | currency: "EUR":"symbol":"1.0-0"
                  }}
                </div>
              </div>
            </div>
          </div></a
        >
      </div>
      <div style="margin-top: 6em" class="col-lg-2 col-md-2 col-sm-0"></div>
      <div
        [@fadeInLeft]="animationState"
        style="margin-top: 6em"
        class="col-lg-4 col-md-4 col-sm-12"
      >
        <a
          style="color: #212529 !important; text-decoration: none !important"
          (click)="saveDecisionAndLoadNextItem($event, 1)"
          ><div
            (click)="animate()"
            class="d-flex flex-column align-items-center app-card"
          >
            <div class="row app-brand-name">
              <div class="col-lg-2 col-md-2 col-sm-0"></div>
              <div class="col-lg-5 col-md-5 col-sm-12">
                {{ stimuli[id][1].brandName }}
              </div>
              <div class="col-lg-2 col-md-2 col-sm-0"></div>
            </div>
            <div>
              <img
                class="app-brand-image"
                [src]="getImageFilePath(stimuli[id][1].brandImage)"
              />
            </div>
            <div class="d-flex flex-column">
              <div style="margin-top: 1em" class="row">
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Karosserie
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>

                <div class="col-lg-5 col-md-5 col-sm-5">
                  <img
                    style="width: 70px"
                    [src]="getImageFilePath(stimuli[id][1].productSegment)"
                  />
                </div>
              </div>
              <div style="margin-top: 11px" class="row">
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Leistung
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
                <div class="col-lg-5 col-md-4 col-sm-5">
                  <ng-template #t let-fill="fill">
                    <span class="star" [class.full]="fill === 100">
                      <span class="half" [style.width.%]="fill">&bull;</span
                      >&bull;
                    </span>
                  </ng-template>
                  <ngb-rating
                    [(rate)]="stimuli[id][1].productPerformance"
                    [readonly]="true"
                    [max]="5"
                    [starTemplate]="t"
                  ></ngb-rating>
                </div>
              </div>
              <div class="row">
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Komfort
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
                <div class="col-lg-5 col-md-5 col-sm-5">
                  <ng-template #t let-fill="fill">
                    <span class="star" [class.full]="fill === 100">
                      <span class="half" [style.width.%]="fill">&bull;</span
                      >&bull;
                    </span>
                  </ng-template>
                  <ngb-rating
                    [(rate)]="stimuli[id][1].productComfort"
                    [readonly]="true"
                    [max]="5"
                    [starTemplate]="t"
                  ></ngb-rating>
                </div>
              </div>
              <div
                style="margin-bottom: 1.8em; margin-top: -0.25em"
                class="row"
              >
                <div class="app-brand-feature col-lg-5 col-md-5 col-sm-5">
                  Preis
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
                <div
                  style="margin-top: 0.3em"
                  class="col-lg-5 col-md-5 col-sm-5"
                >
                  {{
                    stimuli[id][1].productPrice
                      | currency: "EUR":"symbol":"1.0-0"
                  }}
                </div>
              </div>
            </div>
          </div></a
        >
      </div>
    </div>
    <div style="margin-top: 4.8em" class="row">
      <div class="col-lg-2 col-md-2 col-sm-0"></div>
      <div style="text-align: center" class="col-lg-8 col-md-8 col-sm-12">
        <div style="font-size: 24px; font-weight: 600">
          Welches Produkt würdest du eher kaufen?
        </div>

        <div style="font-size: 18px; margin-top: 17px">
          Bitte wähle mit Mausklick die entsprechende Karte aus!
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-12">
        <!--        <button
          type="button"
          class="btn btn-outline-secondary app-btn"
          ngbPopover="Bitte schaue dir aufmerksam die Produkteigenschaften auf den dargestellten Karten an und wähle die Karte mit dem Produkt aus, welches du mit den dargestellten Eigenschaften eher kaufen würdest."
          triggers="mouseenter:mouseleave"
          popoverTitle="Anweisungen"
        > -->
        <div
          class="help-btn"
          ngbPopover="Bitte schaue dir aufmerksam die Produkteigenschaften auf den dargestellten Karten an und wähle die Karte mit dem Produkt aus, welches du mit den dargestellten Eigenschaften eher kaufen würdest."
          triggers="mouseenter:mouseleave"
          popoverTitle="Anweisungen"
        >
          <!-- <img style="width: 70px" [src]="getImageFilePath('info.png')" /> -->
        </div>

        <!-- </button> -->
      </div>
    </div>
  </div>
</div>
